import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import { APIURL } from '../../Global';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import '../../styles/otpverification.css';

const OtpVerificationPage = (props) => {
    const { t } = useTranslation();
    const [emailOtp, setEmailOtp] = useState('');
    const [phoneOtp, setPhoneOtp] = useState('');
    const [emailVerified, setEmailVerified] = useState(false);
    const [phoneVerified, setPhoneVerified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [activeMethod, setActiveMethod] = useState(null);

    const alert = useAlert();

    const handleSend = (method) => {
        setActiveMethod(method);
        setIsSending(true);

        let data = {};
        if (method === "email") {
            data = {
                email: props.datas.email,
            };
        } else {
            data = {
                code: props.datas.code.slice(1),
                mobile_number: props.datas.phone,
            };
        }

        axios
            .post(
                `${APIURL}/api/v1/account/send-otp/`,
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                if (res.status === 200 && res.data.status === "success") {
                    alert.success(t('otpVerification.successMessages.otpSent', { method: method }));
                    // alert.success(`OTP sent to your ${method}`);
                } else {
                    // alert.error('Failed to send OTP. Try again!');
                    alert.error(t('otpVerification.errorMessages.sendFailed'));
                }
            })
            .catch((err) => {
                // alert.error('Failed to send OTP. Try again!');
                alert.error(t('otpVerification.errorMessages.sendFailed'));
            })
            .finally(() => {
                setIsSending(false);
            });
    };

    const submitOTP = (method) => {
        const otp = method === 'email' ? emailOtp : phoneOtp;

        if (!otp) {
            // alert.error('Please enter OTP');
            alert.error(t('otpVerification.errorMessages.enterOTP'));
            return;
        }

        setIsLoading(true);
        let data = {};
        if (method === "email") {
            data = {
                email: props.datas.email,
                otp: Number(otp),
                requested_user: 'hospital'
            };
        } else {
            data = {
                code: props.datas.code,
                mobile_number: props.datas.phone,
                otp: Number(otp),
                requested_user: 'hospital'
            };
        }

        axios
            .post(
                `${APIURL}/api/v1/account/verify-otp/`,
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                if (res.data.status === "success") {
                    if (method === "email") {
                        setEmailVerified(true);
                        setEmailOtp('');
                        // alert.success('Email verified successfully');
                    } else {
                        setPhoneVerified(true);
                        setPhoneOtp('');
                        // alert.success('Phone verified successfully');
                    }

                    alert.success(t(`otpVerification.successMessages.${method}`));
                    setActiveMethod(null);
                } else {
                    // alert.error('Invalid OTP. Please try again.');                    
                    alert.error(t('otpVerification.errorMessages.invalidOTP'));
                }
            })
            .catch((err) => {
                // alert.error('Verification failed. Please try again.');                
                alert.error(t('otpVerification.errorMessages.invalidOTP'));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleProceed = () => {
        if (emailVerified && phoneVerified) {
            props.onClose();
            props.onSuccess();
        } else {
            alert.error(t('otpVerification.errorMessages.verifyBoth'));
            // alert.error('Please verify both email and phone before proceeding');
        }
    };

    return (
        <div>
            <Modal
                {...props}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                show={true}
                className="verification-modal"
            >
                <Modal.Header closeButton onHide={props.onClose}>
                    <Modal.Title className="verification-title"> {t('otpVerification.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="verification-container">
                        <div className="verification-intro">
                            <h5>{t('otpVerification.completeVerification')}</h5>
                            <p className="verification-subtext">
                                {t('otpVerification.bothMustVerify')}
                            </p>
                        </div>

                        {/* Email Verification Section */}
                        <div className={`verification-card ${emailVerified ? 'verified' : ''}`}>
                            <div className="verification-header">
                                <div className="verification-info">
                                    <div className="verification-type">
                                        {t('otpVerification.emailVerification')}
                                    </div>
                                    <div className="verification-value">{props.datas.email}</div>
                                </div>
                                <div className="verification-action">
                                    {emailVerified ? (
                                        <span className="verification-badge">
                                            {t('otpVerification.verified')}
                                        </span>
                                    ) : activeMethod === "email" ? (
                                        <button className="btn-outline" onClick={() => handleSend("email")}>
                                            {isSending && activeMethod === "email"
                                                ? t('otpVerification.sending')
                                                : t('otpVerification.resendOTP')}
                                        </button>
                                    ) : (
                                        <button className="btn-primary" onClick={() => handleSend("email")}>
                                            {t('otpVerification.verifyEmail')}
                                        </button>
                                    )}
                                </div>
                            </div>

                            {activeMethod === "email" && !emailVerified && (
                                <div className="otp-section">
                                    <div className="otp-form">
                                        <input
                                            type="text"
                                            placeholder={t('otpVerification.enterOTP')}
                                            value={emailOtp}
                                            onChange={(e) => setEmailOtp(e.target.value)}
                                        />
                                        <button className="btn-verify" onClick={() => submitOTP("email")}>
                                            {isLoading
                                                ? t('otpVerification.verifying')
                                                : t('otpVerification.submit')}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className={`verification-card ${phoneVerified ? 'verified' : ''}`}>
                            <div className="verification-header">
                                <div className="verification-info">
                                    <div className="verification-type">
                                        {t('otpVerification.phoneVerification')}
                                    </div>
                                    <div className="verification-value">
                                        {props.datas.code} {props.datas.phone}
                                    </div>
                                </div>
                                <div className="verification-action">
                                    {phoneVerified ? (
                                        <span className="verification-badge">
                                            {t('otpVerification.verified')}
                                        </span>
                                    ) : activeMethod === "phone" ? (
                                        <button
                                            className="btn-outline"
                                            onClick={() => handleSend("phone")}
                                            disabled={isSending && activeMethod === "phone"}
                                        >
                                            {isSending && activeMethod === "phone"
                                                ? t('otpVerification.sending')
                                                : t('otpVerification.resendOTP')}
                                        </button>
                                    ) : (
                                        <button
                                            className="btn-primary"
                                            onClick={() => handleSend("phone")}
                                            disabled={isSending || phoneVerified}
                                        >
                                            {t('otpVerification.verifyPhone')}
                                        </button>
                                    )}
                                </div>
                            </div>

                            {activeMethod === "phone" && !phoneVerified && (
                                <div className="otp-section">
                                    <div className="otp-form">
                                        <input
                                            type="text"
                                            placeholder={t('otpVerification.enterOTP')}
                                            value={phoneOtp}
                                            onChange={(e) => setPhoneOtp(e.target.value)}
                                            disabled={isLoading || isSending}
                                            className="otp-input"
                                        />
                                        <button
                                            className="btn-verify"
                                            onClick={() => submitOTP("phone")}
                                            disabled={isLoading || isSending || !phoneOtp}
                                        >
                                            {isLoading
                                                ? t('otpVerification.verifying')
                                                : t('otpVerification.submit')}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="verification-status">
                            <div className="status-indicator">
                                <div className="status-circle">
                                    <span className={`status-icon ${emailVerified ? 'completed' : ''}`}>
                                        {emailVerified ? '✓' : '1'}
                                    </span>
                                </div>
                                <div className="status-text">{t('otpVerification.email')}</div>
                            </div>
                            <div className="status-line"></div>
                            <div className="status-indicator">
                                <div className="status-circle">
                                    <span className={`status-icon ${phoneVerified ? 'completed' : ''}`}>
                                        {phoneVerified ? '✓' : '2'}
                                    </span>
                                </div>
                                <div className="status-text">{t('otpVerification.phone')}</div>
                            </div>
                            <div className="status-line"></div>
                            <div className="status-indicator">
                                <div className="status-circle">
                                    <span className={`status-icon ${(emailVerified && phoneVerified) ? 'ready' : ''}`}>
                                        3
                                    </span>
                                </div>
                                <div className="status-text">{t('otpVerification.complete')}</div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="verification-footer">
                    <button className="btn-proceed active" onClick={props.onClose}>
                        {t('otpVerification.cancel')}
                    </button>
                    <button
                        className={`btn-proceed ${emailVerified && phoneVerified ? 'active' : 'disabled'}`}
                        onClick={handleProceed}
                        disabled={!emailVerified || !phoneVerified}
                    >
                        {t('otpVerification.proceedRegistration')}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default OtpVerificationPage;